"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.process.failed': 'Nie udało się przetworzyć nagrania',
};
